import React from 'react';

function InstagramSvg({ className }) {
  return (
    <svg
      className={className}
      width="88"
      height="58"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64 4H24C12.9543 4 4 12.9543 4 24V64C4 75.0457 12.9543 84 24 84H64C75.0457 84 84 75.0457 84 64V24C84 12.9543 75.0457 4 64 4Z"
        stroke="#F7F6F6"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.9998 41.4812C60.4935 44.8102 59.9248 48.2101 58.3748 51.1973C56.8248 54.1845 54.3724 56.6069 51.3663 58.1199C48.3602 59.6329 44.9536 60.1596 41.6309 59.6249C38.3083 59.0903 35.2388 57.5215 32.8592 55.1418C30.4795 52.7622 28.9107 49.6927 28.3761 46.3701C27.8414 43.0474 28.3681 39.6408 29.8811 36.6347C31.3942 33.6286 33.8165 31.1762 36.8037 29.6262C39.7909 28.0762 43.1908 27.5076 46.5198 28.0012C49.9155 28.5047 53.0592 30.0871 55.4866 32.5144C57.914 34.9418 59.4963 38.0855 59.9998 41.4812Z"
        stroke="#F7F6F6"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66 22H66.0395"
        stroke="#F7F6F6"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default InstagramSvg;
